import React, { Component } from "react";

import { Icon, PlainButton } from "@culturehq/components";

import NotificationDrawer from "components/notifications/NotificationDrawer";
import { t } from "app/utils";
import NotificationPopupWrapper from "components/notifications/NotificationPopupWrapper";

class NotificationBell extends Component {
  state = { drawerOpen: false };

  handleDrawerOpen = async event => {
    const { onOpen } = this.props;

    // This is necessary so that the drawer doesn't see this event and then
    // attempt to close itself.
    event.stopPropagation();

    this.setState({ drawerOpen: true });
    onOpen();
  };

  handleDrawerClose = () => {
    const { onClose } = this.props;

    this.setState({ drawerOpen: false });
    onClose();
  };

  render() {
    const { seenNotifications, unseenNotifications, unseen } = this.props;
    const { drawerOpen } = this.state;

    return (
      <div className="chq-nav--noti">
        <div className="chq-nav--notit chq-nav--notit-bell" onClick={this.handleDrawerOpen}>
          <PlainButton aria-label={t(`${unseen} new notification ${unseen > 1 ? "s" : ""}`)}>
            <Icon icon="ios-bell" />
            {unseen > 0 && <em>{unseen}</em>}
          </PlainButton>
        </div>
        <NotificationDrawer
          open={drawerOpen}
          seenNotifications={seenNotifications}
          unseenNotifications={unseenNotifications}
          onDrawerClose={this.handleDrawerClose}
        />
        <NotificationPopupWrapper />
      </div>
    );
  }
}

export default NotificationBell;
